/** Retired shell overflow keys. Providers may not reintroduce these. */
export const RETIRED_OVERFLOW_KEYS = ['allMessages'];

/**
 * Shell-owned conversation overflow keys.
 * Navigation stays on the visible Back button, so All messages is not a key.
 */
export function shellHeaderOverflowPlan(_temp) {
  let {
    canCompose = false
  } = _temp === void 0 ? {} : _temp;
  return canCompose ? ['newMessage'] : [];
}
export function omitRetiredOverflowKeys(list) {
  if (!list || typeof list.remove !== 'function') return list;
  RETIRED_OVERFLOW_KEYS.forEach(key => list.remove(key));
  return list;
}

/**
 * Keys that remain after provider items are merged under the shell plan.
 * Retired keys are dropped even when a provider still emits them.
 */
export function visibleOverflowKeys(_temp2) {
  let {
    canCompose = false,
    providerKeys = []
  } = _temp2 === void 0 ? {} : _temp2;
  const retired = new Set(RETIRED_OVERFLOW_KEYS);
  const keys = [];
  const push = key => {
    if (!key || retired.has(key) || keys.includes(key)) return;
    keys.push(key);
  };
  providerKeys.forEach(push);
  shellHeaderOverflowPlan({
    canCompose
  }).forEach(push);
  return keys;
}
flarum.reg.add('flatrate-messaging-ui', 'forum/utils/shellOverflowPolicy', { RETIRED_OVERFLOW_KEYS: RETIRED_OVERFLOW_KEYS,shellHeaderOverflowPlan: shellHeaderOverflowPlan,omitRetiredOverflowKeys: omitRetiredOverflowKeys,visibleOverflowKeys: visibleOverflowKeys, });